<template>
<footer class="footer">
  <div class="footer_in">
  <h1 class="footer_ttl">
    <img src="../assets/md_logo.svg" alt="MAZE DOLL" class="footer_ttlImg">
  </h1>
  <div class="footer_nav">
  <ul class="footer_navList">
    <li class="footer_navItem"><router-link to="./" class="footer_navLink"><span class="footer_navLinkTxt">Top</span></router-link></li>
    <li class="footer_navItem"><router-link to="./intro" class="footer_navLink"><span class="footer_navLinkTxt">Introduction</span></router-link></li>
    <li class="footer_navItem"><router-link to="./character" class="footer_navLink"><span class="footer_navLinkTxt">Character</span></router-link></li>
    <li class="footer_navItem"><router-link to="./special" class="footer_navLink"><span class="footer_navLinkTxt">Special</span></router-link></li>
    </ul> 
    <div class="footer_info">
      <dl class="footer_share">
        <dt class="footer_shareTtl"><span class="footer_shareTtlTxt">Share</span></dt>
        <dd class="footer_shareItem"><a href="https://twitter.com/intent/tweet?hashtags=AcuticNotes,MAZEDOLL&amp;text=MAZEDOLL%20PROJECT&amp;url=http%3a%2f%2facutic%2enet%2fACAL%2d0010%2f" class="footer_shareLink"><img src="../assets/tw_logo.svg" alt="Twitter" class="footer_twImg"></a></dd>
        <dd class="footer_shareItem"><a href="http://www.facebook.com/share.php?u=http%3a%2f%2facutic%2enet%2fACAL%2d0010%2f" class="footer_shareLink"><img src="../assets/fb_logo.svg" alt="Facebook" class="footer_fbImg"></a></dd>
             <dd class="footer_shareItem"><a href="https://social-plugins.line.me/lineit/share?url=http%3a%2f%2facutic%2enet%2fACAL%2d0010%2f" class="footer_shareLink"><img src="../assets/line_logo.svg" alt="LINE" class="footer_lineImg"></a></dd>

      </dl>
      <dl class="footer_twitterAccount">
        <dt class="footer_twitterAccountTtl"><img src="../assets/tw_logo.svg" alt="official twitter account" class="footer_twAccountImg"></dt>
        <dd class="footer_twitterAccountName"><a href="https://twitter.com/acuticnotes__jp" class="footer_twitterAccountLink">@AcuticNotes__JP</a></dd>
      </dl>
    </div>
  </div>
  <p class="footer_right">© AcuticNotes All Rights Reserved.</p>
<button class="footer_scrollBtn" v-on:click="scrollToTop"><span class="footer_scrollTxt">Page top</span></button>

  </div>
</footer>
</template>

<script>

export default {
  data: () => {
    return {isActive: false}
  },
  methods: {
    toggleMenu () {
      this.isActive = !this.isActive
    },
    scrollTo (element, to, duration){
      var start = element.scrollY,
          change = to - start,
          currentTime = 0,
          increment = 20
              
      var animateScroll = function(){
          currentTime += increment
          var val = easeInOutQuad(currentTime, start, change, duration)

         element.scrollTo(0,val)
          if(currentTime < duration) {
              setTimeout(animateScroll, increment)
          }
    
      };
      var easeInOutQuad= function (t, b, c, d) {
        t /= d/2;
        if (t < 1) return c/2*t*t + b;
        t--;
        return -c/2 * (t*(t-2) - 1) + b;
      }
      animateScroll()
    },
    scrollToTop (){
      this.scrollTo(window, 0, 600);
    }
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.footer{
 font-family: 'DIN Next LT W01 Bold', 'Avenir', Helvetica, Arial, sans-serif;
   font-size: 18px;
   text-align: left;
   //margin-top: 72px;
@include mq(){
  margin-top: 0;
}
   &_in{
     max-width: 1600px;
     margin:0 auto;
        padding:36px;
        position: relative;
        @include mq(){
          padding: 8px 16px 36px;
        }
   }
     &_navList{
  //  display: flex;
    list-style-type: none;
  }
  &_nav{
    margin-top: 48px;
    @include mq(){
      display: flex;
          justify-content: space-between;
          align-items: flex-end;
          margin-top: 0;
    }
  }
  &_navItem{
    display: inline-block;
  margin-right: 36px;
  @include mq(){
    margin-right:0;
    display: block;
    margin-top: 8px;
  }
  }
  &_navLink{
    display: block;
    //padding: 16px;
    text-decoration: none;
     text-transform: uppercase;
     letter-spacing: .05em;
     @include mq(){
       font-size: 12px;
       display: inline-block;
     }
     
  }
  &_navLinkTxt {

    position: relative;
    display: inline-block;
    padding: 2px 2px 2px 4px;
    line-height: 1;
    @include mq(){
      padding: 0;
    }
  }
    &_navLinkTxt::before {
    content: '';
    position: absolute;
    width: 0;
    height: 100%;
    z-index: -1;
    transition: all .2s ease;
    left: 0;
    top: 0;

  }

  &_navLink:hover &_navLinkTxt {
    color: #fff;

    &::before {
      background-color: #000;
      width: 100%;

    }
  }

  &_navLink.router-link-exact-active {
    cursor: default;
  }

  &_navLink.router-link-exact-active &_navLinkTxt {

    color: #000;
  }

  &_navLink.router-link-exact-active &_navLinkTxt::before {
    top: auto;
    bottom: -4px;
    width: 100%;
    height: 1px;
    background-color: #000;
  }
  &_navLink:not([href]){
    color: #ccc;
    position: relative;
    &::after{
      content:'';
      display: block;
      width: 100%;
      height: 1px;
      background-color: #ccc;
      position: absolute;
      top: 50%;
      left: 0;
      @include mq(){
        left: 0;
        width: 100%;
      }
    }
  }
  &_info{
    display: flex;
    margin-top: 48px;
    @include mq(){
      display: block;
      font-size: 12px;
      text-align: right;
    }
  }
  &_shareTtl{
     &::after{
      content:'';
      width: 18px;
      height: 18px;
      display: inline-block;
      background: url(../assets/icon_suffix.svg) center center no-repeat;
      vertical-align: middle;
          @include mq(){
            width: 10px;
    height: 10px;
      }
    }
  }
  &_shareTtlTxt{
    display: inline-block;
    text-transform: uppercase;
    letter-spacing: .05em;
    vertical-align: middle;
    line-height: 1;
  }
  &_shareTtl,
  &_shareItem{
     display: inline-block;
     margin-right:16px;
     vertical-align: middle;
     @include mq(){
           margin-right: 0;
           margin-left: 12px;
     }
    
  }
  &_shareLink{
    display: block;
    transition: all .2s ease;
    &:hover{
      opacity: .7;
    }
  }
  &_twImg,
  &_fbImg,
  &_lineImg{
    width: 20px;
    height:auto;
    display: block;
  }
  &_twitterAccount{
    margin-left: 24px;
     @include mq(){
    margin-left: 0;
    margin-top: 12px;
    }
  }
   &_twAccountImg{
    width: 16px;
    height:auto;
    display: block;
    @include mq(){
      width: 16px;
    }
  }
  &_twitterAccountTtl,
  &_twitterAccountName{
    display: inline-block;
    vertical-align: middle;
  }
  &_twitterAccountName{
        margin-left: 4px;
  }
   &_ttlImg {
     height: 48px;
    @include mq() {
      font-size: 24px;
          height: 24px;
    }
  }
  &_right{
    margin-top: 36px;
    color: #999;
      font-family: 'DIN Next LT W01 Regular', 'Avenir', Helvetica, Arial, sans-serif;
      font-size: 14px;
@include mq(){
  text-align: center;
  font-size: 10px;
}
  }
  &_scrollBtn{
    position: absolute;
    right: 36px;
    bottom:36px;
    @include mq(){
      display: none;
    }
    
  }
  &_scrollTxt{
    position: relative;
    &::before{
      position: absolute;

      content:'';
      width:72px;
      height: 72px;
      background: url(../assets/icon_top.svg) center center no-repeat;
      bottom: 8px;
      transition: bottom .2s ease;
      
    }
    &:hover::before{
        bottom:12px;
      }
    font-size: 16px;
    text-transform: uppercase;
    letter-spacing: .05em;
  }
  &_twitterAccountLink{
    text-decoration: none;
  }
}
</style>
